import { Button } from '@ws/shared/components';
import { Check24 } from '@ws/shared/icons';
import { classes } from 'classifizer';
import { useCallback, useEffect } from 'react';

import { BusEventType, eventBus } from '../../../../utils/EventBus';

import styles from './CompleteButton.module.css';

interface ICompleteButtonProps {
  onClick(): void;
  isDesktopOnly?: boolean;
  isNotDesktop?: boolean;
}

export function CompleteButton({ onClick, isDesktopOnly, isNotDesktop }: ICompleteButtonProps) {
  const handleClick = useCallback(() => {
    onClick();
  }, [onClick]);

  useEffect(() => {
    if (!isNotDesktop) {
      return;
    }

    eventBus.emit(BusEventType.COMPLETE_EDIT_BTN_MOUNTED, undefined);
    return () => {
      eventBus.emit(BusEventType.COMPLETE_EDIT_BTN_UNMOUNTED, undefined);
    };
  }, [isNotDesktop]);

  useEffect(() => {
    if (!isNotDesktop) {
      return;
    }

    eventBus.on(BusEventType.COMPLETE_EDIT_BTN_CLICKED, handleClick);
    return () => {
      eventBus.off(BusEventType.COMPLETE_EDIT_BTN_CLICKED, handleClick);
    };
  }, [isNotDesktop, handleClick]);

  if (isNotDesktop) {
    return null;
  }

  return (
    <Button
      variant="shapeless"
      icon={<Check24 color="other_success" />}
      onClick={handleClick}
      className={classes(
        styles['complete-button'],
        isDesktopOnly && styles['complete-button_desktop-only'],
      )}
    />
  );
}
